import React, { useContext, useState } from "react";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";
import { motion, AnimatePresence } from 'framer-motion';
import { CloseOutlined, CloudUploadOutlined } from "@mui/icons-material";
import { AlertContext } from "../../../contexts/AlertContext";
import { IconButton } from "@mui/material";
import { CustomInputArea } from "../../CustomInputArea";
import { CustomInputText } from "../../CustomInputText";
import { formatearValor } from "../../../helpers/formatearPesos";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const OffAssetForm = ({ data, action }) => {

    const [selectedImage, setSelectedImage] = useState('');
	const [previousImage, setPreviousImage] = useState('');
    const [error, setError] = useState(false);
    const { alertRef } = useContext(AlertContext);
    const { handleSubmit, control, formState: { errors } } = useForm();

    const changeImage = (e) => {
		if(!e.target.files[0]) return;

		const extension = e.target.files[0]?.name?.split('.').at(-1);
		const extensionesPermitidas = ['png', 'jpg', 'jpeg'];

		if(!extensionesPermitidas?.includes(extension)) {
			return alertRef?.current?.handleOpen('error', `La extensión ${ extension } no es permitida, intente con (${ extensionesPermitidas.join(', ') })`);
		}

		setPreviousImage(URL.createObjectURL(e.target.files[0]));

		setSelectedImage({
			name: e.target.files[0]?.name,
			type: e.target.files[0]?.type,
			buffer: e.target.files[0]
		});

        setError(false);
	}

	const removeImage = () => {
		setPreviousImage('');
		setSelectedImage('');
        setError(true);
	}

    const onSubmit = (fields) => {
        if(!selectedImage) return setError(true);

        action({ ...fields, imagen: selectedImage })
    }

	return (
        <form onSubmit={ handleSubmit(onSubmit) }
            style={{ 
                background: "#fff",
                width: '35vw',
                padding: 20,
                overflowY: 'auto',
                scrollbarWidth: 'none'
            }}
        >
            <div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 15
				}}
			>
                <CustomInputText
                    disabled={ true }
                    label='Responsable'
                    placeholder=''
                    value={ convertirLetraMayus(data?.responsable?.usuario?.nombre, true) || '' }
                />

                <CustomInputText
                    disabled={ true }
                    label='Valor de compra'
                    placeholder=''
                    value={ `$ ${formatearValor(data?.valor_compra)}` || '' }
                />
			</div>

            <Controller 
				name='motivo'
				control={ control }
				defaultValue=''
				render={ ({ field: { onChange, value } }) => (
					<CustomInputArea
						label='Motivo de baja'
						placeholder=''
						onChange={ onChange }
						value={ value }
						error={ errors?.motivo }
					/>
				)}

				rules={{ required: '* El campo es obligatorio.' }}
			/>

			<Controller 
				name='disposicion'
				control={ control }
				defaultValue=''
				render={ ({ field: { onChange, value } }) => (
					<CustomInputArea
						label='Disposición final'
						placeholder=''
						onChange={ onChange }
						value={ value }
						error={ errors?.disposicion }
						rows={ 2 }
					/>
				)}

				rules={{ required: '* El campo es obligatorio.' }}
			/>

            <div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 15
				}}
			>
                <CustomInputText
                    disabled={ true }
                    label='Número de placa'
                    placeholder=''
                    value={ data?.placa }
                    
                />
				
                <CustomInputText
                    disabled={ true }
                    label='Código inteligente'
                    placeholder=''
                    value={ data?.codigo_inteligente?.toUpperCase() }
                />
			</div>

            <CustomInputText
                disabled={ true }
                label='Categoria'
                placeholder=''
                value={ convertirLetraMayus(data?.categoria?.nombre) }
            />

            <div
				style={{
                    position: 'relative',
                    borderWidth: 2,
                    borderStyle: 'dashed',
                    borderColor: error ? '#d32f2f' : '#a3a3a3',
                    borderRadius: 4,
                    minHeight: 115,
                    height: 'auto'
				}}
			>
				{
					!previousImage && (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							<label htmlFor="file" style={{ 
								fontWeight: 550,
								fontSize: 12,
								color: '#a3a3a3',
								cursor: 'pointer',
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)'
							}}>
								<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
									<CloudUploadOutlined />
									Seleccionar imagen
								</div>
							</label>
							<input
								id='file' 
								type="file"
								accept="image/png, image/jpeg, image/jpg"
								onChange={ changeImage }
								aria-label="Seleccionar imagen"
								style={{ display: 'none' }}
							/>
						</motion.div>
					)
				}

				<AnimatePresence initial={ false }>
					{
						previousImage && (		
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
	
								style={{ 
									position: 'relative', 
									background: 'tomato', 
									display: 'flex', 
									width: 'fit-content', 
									borderRadius: 4, 
									overflow: 'hidden', 
									margin: 5 
								}}
							>
								<img src={ previousImage } alt='previous image' width={100} height={100} style={{ position: 'relative'}} />
								<div style={{ position: 'absolute', background: '#000', width: 20, height: 20, opacity: .8, borderRadius: '50%', top: 5, right: 5 }} />
					
								<IconButton style={{ position: 'absolute', top: 0, right: 0 }} onClick={ removeImage }>
									<CloseOutlined htmlColor="#fff" style={{ color: '#fff', fontSize: 14 }} />
								</IconButton>
							</motion.div>
						)
					}
				</AnimatePresence>
			</div>
            
            <div style={{ marginBottom: 15 }}>
                { error && <span style={{ fontSize: 12, color: '#d32f2f', marginLeft: 5, }}>* Debe seleccionar una imagen.</span> }
            </div>

            <CustomButtonsForm name='Procesar' />
        </form>
    )
}